import React from "react";
import { splitBullets, toBlocks } from "./copyBlocks";

/*
 * Renders a block of service copy — see copyBlocks.js for the shape it parses.
 * A block's first line is its sub-heading when it reads like one: short, and
 * not closed like a sentence.
 *
 * Headings are emitted as real <h3> elements and paragraphs as <p>. The
 * previous version emitted bolded <div>s for both, which cost the page its
 * heading hierarchy and, because _typography.scss assigns a font family by
 * element name and never lists <div>, silently dropped every paragraph onto
 * the <body> font while the bullets beside them kept the heading font.
 */

const readsAsHeading = (line) =>
  line.length < 120 && !line.endsWith(".") && !line.endsWith("。");

const renderFormattedText = (text) => {
  if (!text) return null;

  const blocks = toBlocks(text);

  if (blocks.length === 0) return null;

  return (
    <div className="service-prose">
      {blocks.map((lines, blockIndex) => {
        const { prose, bullets } = splitBullets(lines);

        // A line with nothing following it is a paragraph in its own right,
        // not a heading introducing an empty section.
        const leadsWithHeading =
          prose.length > 0 &&
          (prose.length > 1 || bullets.length > 0) &&
          readsAsHeading(prose[0]);

        return (
          <div className="service-prose-block" key={blockIndex}>
            {prose.map((line, lineIndex) =>
              lineIndex === 0 && leadsWithHeading ? (
                <h3 className="service-prose-heading" key={lineIndex}>
                  {line}
                </h3>
              ) : (
                <p key={lineIndex}>{line}</p>
              )
            )}
            {bullets.length > 0 && (
              <ul className="service-prose-list">
                {bullets.map((bullet, bulletIndex) => (
                  <li key={bulletIndex}>{bullet}</li>
                ))}
              </ul>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default renderFormattedText;
